<template>
  <time class="text-sm font-medium" style="color: #7f8083" :datetime="publishedDate">{{ articleDate }}</time>
</template>

<script>
import { computed, defineComponent, inject, ref } from '@nuxtjs/composition-api';
import { dayjs, timeDifference } from '~/modules/common/utils/dateUtils';

export default defineComponent({
  setup() {
    const article = inject('article', null);
    // const publishedDate = computed(() => dayjs().format(article.dates?.updated));
    const publishedDate = computed(() => dayjs.utc(article.dates?.updated).tz('Europe/Istanbul').format());

    const time = ref(null);
    time.value = timeDifference(article.dates?.updated);

    return { publishedDate, articleDate: time };
  },
});
</script>
